import { RouteObject } from "react-router";
import { setupMakePaymentRoutes } from "src/router/routes/common/MakePayment";

export const FinancingRoutes: RouteObject[] = [
  {
    path: "payments",
    async loader(args) {
      const { paymentsLoader } = await import("src/router/loaders/jobs/Financing");
      return paymentsLoader(args);
    },
    async lazy() {
      const { Payments } = await import("jobs/Job/FinancingTab/Payments");
      return { element: <Payments /> };
    },
  },
  {
    path: "payment_requests",
    async loader(args) {
      const { paymentRequestsLoader } = await import("src/router/loaders/jobs/Financing");
      return paymentRequestsLoader(args);
    },
    async lazy() {
      const { PaymentRequests } = await import("jobs/Job/FinancingTab/PaymentRequests");
      return { element: <PaymentRequests /> };
    },
  },
  {
    path: "finance_applications",
  },
  {
    path: "",
    async loader(args) {
      const { rootFinancingLoader } = await import("src/router/loaders/jobs/Financing");
      return rootFinancingLoader(args);
    },
  },
  ...setupMakePaymentRoutes(),
];
